const SettingsSections = {
    SECURITY: 'security',
    USERS: 'users',
    ORGANIZATIONS: 'organizations',
    LMS: 'lms',
}

export default SettingsSections
